module.exports = __webpack_public_path__ + "img/2fa.166495ce.svg";